<template>
  <div class="box-card-new">
    <div class="card">
      <span class="kadenze-review-card kd-card kd-card--review-card">
        <span v-if="review.user_id">
        <a :href="review.user_profile_path">
          <img :src="review.user_image" alt="Image" class="kd-card__img img-responsive">
        </a>
        </span>
        <span v-else> 
          <div class="kd-card__img img-responsive">
            <a :href="review.user_profile_path">{{review.user_char}}</a>
          </div>
        </span>
        <div class="kd-star" v-if="review.full_stars > 0">
          <span v-for="rating in review.full_stars">
            <i class="orange-color kf kf-star"></i>
          </span>
          <span v-if="review.half_star">
            <i class="kf kf-star half-star" style="background-image: linear-gradient(-90deg, #4b5253 50%, #ffa500 50%);"></i>
          </span>
          <span v-for="rating in review.gray_stars">
            <i class="kf kf-star gray-star"></i>
          </span>
        </div>
        <div class="kd-card__info_item-title">{{review.user_name}}</div>
        <div class="kd-card__info_school" v-html="review.content">{{review.content}}</div>
      </span>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: "reviewCard",

    data() {
      return {
        review_all_path: this.review_analytic.review_all_url
      }
    },

    props: ['review', 'review_analytic']
  }
</script>
